import { call, put } from 'redux-saga/effects';
import { handleServerError } from 'store/alerts/actions';
import { ensureHttpsForTags } from 'functions/ensureHttpsUrl';
import * as tagActions from '../actions';
import * as tagApi from '../api';

function* fetchTagAlsoLike({ payload: { id } }) {
  try {
    const response = yield call(tagApi.fetchYouMintAlsoLike, { id });

    const processedTags = ensureHttpsForTags(response.data);

    yield put(tagActions.recieveAlsoLike(processedTags));
  } catch (error) {
    yield put(handleServerError(error));
  }
}

export default fetchTagAlsoLike;
